/**
 * TextHandler - handles text replacement and formatting
 * This is a complex module that processes RAGS text replacement syntax
 */

import { Finder } from './Finder';
import { DateTimes } from './DateTimes';
import { Interactables } from './Utilities';
import { GetExit } from './Utilities';
import { Variable } from '../models/Variable';
import { Action } from '../models/Action';
import { RagsObject } from '../models/Object';
import { Character } from '../models/Character';
import { Globals } from '../core/Globals';

declare let TheGame: any;

/**
 * Main text replacement function - processes all RAGS text replacement syntax
 */
export function PerformTextReplacements(text: string, loopobject: any, newvalue?: string): string {
    let bChangedSomething = true;
    while (bChangedSomething) {
        bChangedSomething = false;
        let startpt = text.length;
        let tempindex = text.lastIndexOf("[", startpt);
        const foundindexes: number[] = [];
        while (tempindex >= 0) {
            const endindex = text.indexOf("]", tempindex);
            if (endindex != -1) {
                const sub = text.substring(tempindex, endindex + 1).toUpperCase();
                const colindex = sub.indexOf(":", 0);
                if (colindex != -1) {
                    bChangedSomething = true;
                    const subsub = sub.substring(0, colindex + 1).toUpperCase();
                    if (subsub == "[V:")
                        text = ReplaceVariable(text, tempindex, newvalue);
                    else if (subsub == "[JSA:")
                        text = ReplaceJSA(text, tempindex);
                    else if (subsub == "[RP:")
                        text = ReplaceProperty("rp", text, tempindex, newvalue);
                    else if (subsub == "[IP:")
                        text = ReplaceProperty("ip", text, tempindex, newvalue);
                    else if (subsub == "[PP:")
                        text = ReplaceProperty("pp", text, tempindex, newvalue);
                    else if (subsub == "[CP:")
                        text = ReplaceProperty("cp", text, tempindex, newvalue);
                    else if (subsub == "[VP:")
                        text = ReplaceProperty("vp", text, tempindex, newvalue);
                    else if (subsub == "[TP:")
                        text = ReplaceProperty("tp", text, tempindex, newvalue);
                    else if (subsub == "[IA:")
                        text = ReplaceAttribute("ia", text, tempindex, newvalue);
                    else if (subsub == "[TA:")
                        text = ReplaceAttribute("ta", text, tempindex, newvalue);
                    else if (subsub == "[CA:")
                        text = ReplaceAttribute("ca", text, tempindex, newvalue);
                    else if (subsub == "[RA:")
                        text = ReplaceAttribute("ra", text, tempindex, newvalue);
                    else if (subsub == "[PA:")
                        text = ReplaceAttribute("pa", text, tempindex, newvalue);
                    else
                        bChangedSomething = false;
                } else {
                    if (sub.indexOf("[/B]") > -1 || sub.indexOf("[/I]") > -1 || sub.indexOf("[/U]") > -1 || sub.indexOf("[/F]") > -1 || sub.indexOf("[/C]") > -1 || sub.indexOf("[/MIDDLE]") > -1 || sub.indexOf("[B]") > -1 || sub.indexOf("[I]") > -1 || sub.indexOf("[U]") > -1 || sub.indexOf("[F ") > -1 || sub.indexOf("[C ") > -1 || sub.indexOf("[MIDDLE]") > -1) {
                        startpt = tempindex - 1;
                    } else {
                        text = ReplaceStatic(text, tempindex, sub, loopobject);
                    }
                }
            }
            if (startpt > text.length) {
                if (tempindex == 0) {
                    tempindex = -1;
                } else {
                    foundindexes.push(tempindex);
                    tempindex = text.lastIndexOf("[", tempindex - 1);
                    let bfoundinlist = false;
                    for (let k = 0; k < foundindexes.length; k++) {
                        if (foundindexes[k] == tempindex) {
                            bfoundinlist = true;
                            break;
                        }
                    }
                    if (bfoundinlist)
                        tempindex = text.lastIndexOf("[", tempindex - 1);
                }
            } else if (startpt == -1) {
                tempindex = -1;
            } else {
                if (tempindex == 0) {
                    tempindex = -1;
                } else {
                    foundindexes.push(tempindex);
                    tempindex = text.lastIndexOf("[", tempindex - 1);
                    if (foundindexes.indexOf(tempindex) > -1) {
                        tempindex = text.lastIndexOf("[", tempindex - 1);
                    }
                }
            }
        }
    }
    return text;
}

/**
 * Replace variable references in text
 */
function ReplaceVariable(text: string, tempindex: number, replacementvalue?: string | null): string {
    let bReplacement = false;
    if (replacementvalue != null)
        bReplacement = true;
    if (replacementvalue == " ")
        replacementvalue = "";
    if (tempindex >= 0) {
        text = text.slice(0, tempindex) + text.slice(tempindex + 3);
        const endindex = text.indexOf("]", tempindex);
        const endindex2 = text.indexOf("(", tempindex);
        if (endindex2 < endindex && endindex2 != -1) {
            const endindex3 = text.indexOf(")", tempindex);
            if (endindex3 != -1) {
                let varname = text.substring(tempindex, endindex2).trim();
                if (endindex3 - (endindex2 + 1) < 0)
                    return text;
                const arrayindex = text.substring(endindex2 + 1, endindex3).trim();
                let actualindex: string | number = arrayindex;
                let endindex4 = text.indexOf(")", endindex3 + 1);
                if (endindex4 > endindex) {
                    // suspected closing paren of second array index is outside of variable being replaced,
                    // don't consider it an array index
                    endindex4 = -1;
                }
                let actualindex2 = -1;
                if (endindex4 != -1) {
                    try {
                        const tempstr = text.substring(endindex3 + 2, endindex4 + 2);
                        actualindex2 = parseInt(PerformTextReplacements(tempstr, null), 10);
                        if (isNaN(actualindex2)) {
                            actualindex2 = -1;
                            endindex4 = -1;
                        }
                    } catch (err) {
                        actualindex2 = -1;
                        endindex4 = -1;
                    }
                }
                let dtformat = "";
                if (varname.indexOf(":") > -1) {
                    dtformat = varname.substring(varname.indexOf(":") + 1);
                    varname = varname.substring(0, varname.indexOf(":"));
                }
                const tempvar = Finder.variable(varname);
                let newval = "";
                if (tempvar != null) {
                    let lengthtoremove = 0;
                    if (endindex4 > -1)
                        lengthtoremove = endindex4 - tempindex + 2;
                    else
                        lengthtoremove = endindex3 - tempindex + 2;
                    text = text.slice(0, tempindex) + text.slice(tempindex + lengthtoremove);
                    const idx = typeof actualindex === 'number' ? actualindex : parseInt(String(actualindex), 10);
                    if (tempvar.VarArray && idx < tempvar.VarArray.length) {
                        if (tempvar.vartype == "VT_NUMBERARRAY" || tempvar.vartype == "VT_STRINGARRAY" || tempvar.vartype == "VT_DATETIMEARRAY") {
                            if (actualindex2 > -1) {
                                try {
                                    newval = String(tempvar.VarArray[idx][actualindex2]);
                                    if (bReplacement) {
                                        tempvar.VarArray[idx][actualindex2] = replacementvalue as any;
                                    }
                                } catch (err) {
                                    newval = "<invalid variable reference>";
                                }
                            } else {
                                newval = String(tempvar.VarArray[idx]);
                                if (bReplacement) {
                                    if (tempvar.vartype == "VT_NUMBERARRAY") {
                                        tempvar.VarArray[idx] = parseFloat(replacementvalue || "0") as any;
                                    } else {
                                        tempvar.VarArray[idx] = replacementvalue as any;
                                    }
                                }
                            }
                        }
                    }
                    if (!bReplacement)
                        text = text.slice(0, tempindex) + newval + text.slice(tempindex);
                }
            }
        } else if (endindex > -1) {
            let varname = text.substring(tempindex, endindex).trim();
            text = text.slice(0, tempindex) + text.slice(endindex + 1);
            let dtformat = "";
            if (varname.indexOf(":") > -1) {
                dtformat = varname.substring(varname.indexOf(":") + 1);
                varname = varname.substring(0, varname.indexOf(":"));
            }
            const tempvar = Finder.variable(varname);
            if (tempvar != null) {
                let newval = "";
                if (tempvar.vartype == "VT_NUMBER") {
                    newval = tempvar.dNumType.toString();
                    if (bReplacement) {
                        try {
                            tempvar.dNumType = parseFloat(replacementvalue || "0");
                        } catch (err) {
                            tempvar.dNumType = -1.0;
                        }
                    }
                } else if (tempvar.vartype == "VT_STRING") {
                    newval = tempvar.sString;
                    if (bReplacement) {
                        tempvar.sString = replacementvalue || "";
                    }
                } else if (tempvar.vartype == "VT_DATETIME") {
                    if (dtformat != "") {
                        newval = DateTimes.formatDateString(
                            DateTimes.stringDateToDate(tempvar.dtDateTime),
                            dtformat
                        );
                        if (bReplacement) {
                            try {
                                tempvar.dtDateTime = replacementvalue || "";
                            } catch (err) { }
                        }
                    } else {
                        newval = tempvar.dtDateTime.toString();
                        if (bReplacement) {
                            try {
                                tempvar.dtDateTime = replacementvalue || "";
                            } catch (err) { }
                        }
                    }
                }
                if (bReplacement) {
                    newval = PerformTextReplacements(newval, null);
                }
                text = text.slice(0, tempindex) + newval + text.slice(tempindex);
            }
        }
    }
    return text;
}

/**
 * Replace JavaScript array references
 */
function ReplaceJSA(text: string, tempindex: number): string {
    if (tempindex >= 0) {
        text = text.slice(0, tempindex) + text.slice(tempindex + 5);
        const endindex = text.indexOf("]", tempindex);
        if (endindex > -1) {
            const varname = text.substring(tempindex, endindex).trim();
            text = text.slice(0, tempindex) + text.slice(endindex + 1);
            const tempvar = Finder.variable(varname);
            if (tempvar != null) {
                const newval = JavaScriptArray(tempvar);
                text = text.slice(0, tempindex) + newval + text.slice(tempindex);
            }
        }
        tempindex = text.lastIndexOf("[jsa:");
    }
    return text;
}

/**
 * Replace property references
 */
function ReplaceProperty(property: string, text: string, tempindex: number, replacementvalue?: string | null): string {
    let tempobj: any = null;
    let bReplacement = false;
    if (replacementvalue != null)
        bReplacement = true;
    if (replacementvalue == " ")
        replacementvalue = "";
    if (tempindex >= 0) {
        text = text.slice(0, tempindex) + text.slice(tempindex + 4);
        const endindex = text.indexOf("]", tempindex);
        if (endindex > -1) {
            const proptext = text.substring(tempindex, endindex).trim();
            text = text.slice(0, tempindex) + text.slice(endindex + 1);
            const parts = proptext.split(":");
            let partmatch = "";
            if (property == "pp") {
                if (!TheGame) return text;
                tempobj = TheGame.Player;
                partmatch = parts[0].trim();
            } else {
                if (parts.length === 1) {
                    // Property request with no access. Rather than crashing,
                    // we'll replace it with empty string, which seems to be
                    // what the .NET client does.
                    return text;
                }

                partmatch = parts[1].trim();
            }
            if (parts.length > 1) {
                if (property == "rp") {
                    tempobj = Finder.room(parts[0]);
                } else if (property == "ip") {
                    tempobj = Finder.object(parts[0]);
                } else if (property == "cp") {
                    tempobj = Finder.character(parts[0]);
                } else if (property == "vp") {
                    tempobj = Finder.variable(parts[0]);
                } else if (property == "tp") {
                    tempobj = Finder.timer(parts[0]);
                }
            }
            if (tempobj != null && tempobj.CustomProperties) {
                for (let i = 0; i < tempobj.CustomProperties.length; i++) {
                    const prop = tempobj.CustomProperties[i];
                    if (prop.Name.toLowerCase() == partmatch.toLowerCase()) {
                        text = text.slice(0, tempindex) + prop.Value + text.slice(tempindex);
                        if (bReplacement) {
                            prop.Value = replacementvalue || "";
                        }
                        break;
                    }
                }
            }
        }
        tempindex = text.lastIndexOf("[" + property + ":");
    }
    return text;
}

/**
 * Replace attribute references
 */
function ReplaceAttribute(AttType: string, text: string, tempindex: number, replacementvalue?: string | null): string {
    let bReplacement = false;
    if (replacementvalue != null)
        bReplacement = true;
    if (replacementvalue == " ")
        replacementvalue = "";
    if (tempindex >= 0) {
        text = text.slice(0, tempindex) + text.slice(tempindex + 4);
        const endindex = text.indexOf("]", tempindex);
        if (endindex > -1) {
            const proptext = text.substring(tempindex, endindex).trim();
            text = text.slice(0, tempindex) + text.slice(endindex + 1);
            const parts = proptext.split(":");
            let tempobject: any = null;
            if (parts.length >= 1) {
                parts[0] = parts[0].trim();
                if (AttType == "ia") {
                    tempobject = Finder.object(parts[0]);
                } else if (AttType == "ta") {
                    tempobject = Finder.timer(parts[0]);
                } else if (AttType == "ca") {
                    tempobject = Finder.character(parts[0]);
                } else if (AttType == "ra") {
                    tempobject = Finder.room(parts[0]);
                } else if (AttType == "pa") {
                    if (!TheGame) return text;
                    tempobject = TheGame.Player;
                }
                if (tempobject != null) {
                    let proptocheck = "";
                    if (AttType == "pa")
                        proptocheck = parts[0];
                    else
                        proptocheck = parts[1];
                    switch (proptocheck.toUpperCase()) {
                        case "ACTIVE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.Active) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.Active = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "TIMERTYPE":
                            {
                                text = text.slice(0, tempindex) + tempobject.TType + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.TType = replacementvalue || "";
                                }
                                break;
                            }
                        case "LENGTH":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.Length) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.Length = parseInt(replacementvalue || "0", 10);
                                }
                                break;
                            }
                        case "TURNNUMBER":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.TurnNumber) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.TurnNumber = parseInt(replacementvalue || "0", 10);
                                }
                                break;
                            }
                        case "TIMERSECONDS":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.TimerSeconds) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.TimerSeconds = parseInt(replacementvalue || "0", 10);
                                }
                                break;
                            }
                        case "LIVETIMER":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.LiveTimer) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.LiveTimer = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "ACTION":
                            {
                                const tempact = Finder.action(tempobject.Actions, parts[2]);
                                if (tempact != null) {
                                    text = GetActionData(tempact, parts[3], text, tempindex, replacementvalue);
                                }
                                break;
                            }
                        case "NAME":
                            {
                                switch (AttType) {
                                    case "ia":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.name + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.name = replacementvalue || "";
                                            }
                                            break;
                                        }
                                    case "ra":
                                    case "pa":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.Name + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.Name = replacementvalue || "";
                                            }
                                            break;
                                        }
                                    case "ca":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.Charname + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.Charname = replacementvalue || "";
                                            }
                                            break;
                                        }
                                }
                                break;
                            }
                        case "DESCRIPTION":
                            {
                                switch (AttType) {
                                    case "ra":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.Description + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.Description = replacementvalue || "";
                                            }
                                            break;
                                        }
                                    case "ia":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.description + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.description = replacementvalue || "";
                                            }
                                            break;
                                        }
                                }
                                break;
                            }
                        case "SDESC":
                            {
                                text = text.slice(0, tempindex) + tempobject.SDesc + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.SDesc = replacementvalue || "";
                                }
                                break;
                            }
                        case "ROOMPIC":
                            {
                                text = text.slice(0, tempindex) + tempobject.RoomPic + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.RoomPic = replacementvalue || "";
                                }
                                break;
                            }
                        case "ENTEREDFIRSTTIME":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bEnterFirstTime) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bEnterFirstTime = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "LEFTFIRSTTIME":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bLeaveFirstTime) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bLeaveFirstTime = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "ID":
                            {
                                switch (AttType) {
                                    case "ra":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.UniqueID + text.slice(tempindex);
                                            break;
                                        }
                                    case "ia":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.UniqueIdentifier + text.slice(tempindex);
                                            break;
                                        }
                                }
                                break;
                            }
                        case "EXIT":
                            {
                                const tempexit = GetExit(tempobject, parts[2]);
                                if (tempexit != null) {
                                    if (parts[3].toUpperCase() == "ACTIVE") {
                                        text = text.slice(0, tempindex) + String(tempexit.bActive) + text.slice(tempindex);
                                        if (bReplacement) {
                                            tempexit.bActive = (replacementvalue?.toLowerCase() == "true");
                                        }
                                    } else if (parts[3].toUpperCase() == "DESTINATIONID") {
                                        text = text.slice(0, tempindex) + tempexit.DestinationRoom + text.slice(tempindex);
                                        if (bReplacement) {
                                            tempexit.DestinationRoom = replacementvalue || "";
                                        }
                                    } else if (parts[3].toUpperCase() == "DESTINATIONNAME") {
                                        text = text.slice(0, tempindex) + tempexit.DestinationRoom + text.slice(tempindex);
                                        if (bReplacement) {
                                            const room = Finder.room(replacementvalue || "");
                                            if (room) tempexit.DestinationRoom = room.UniqueID;
                                        }
                                    } else if (parts[3].toUpperCase() == "PORTAL") {
                                        text = text.slice(0, tempindex) + tempexit.PortalObjectName + text.slice(tempindex);
                                        if (bReplacement) {
                                            tempexit.PortalObjectName = replacementvalue || "";
                                        }
                                    }
                                }
                                break;
                            }
                        case "NAMEOVERRIDE":
                            {
                                text = text.slice(0, tempindex) + tempobject.sdesc + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.sdesc = replacementvalue || "";
                                }
                                break;
                            }
                        case "CLOTHINGLAYERS":
                            {
                                let layers = "[";
                                let count = 0;
                                if (tempobject.LayeredZoneLevels) {
                                    for (let i = 0; i < tempobject.LayeredZoneLevels.length; i++) {
                                        const str = tempobject.LayeredZoneLevels[i];
                                        if (count > 0)
                                            layers += ",";
                                        count++;
                                        layers += "[";
                                        const strsplit = str.split(":");
                                        if (strsplit.length > 0) {
                                            for (let j = 0; j < strsplit.length; j++) {
                                                if (j > 0)
                                                    layers += ",";
                                                layers += "\"" + strsplit[j] + "\"";
                                            }
                                        }
                                        layers += "]";
                                    }
                                }
                                layers += "]";
                                text = text.slice(0, tempindex) + layers + text.slice(tempindex);
                                break;
                            }
                        case "PREPOSITION":
                            {
                                text = text.slice(0, tempindex) + tempobject.preposition + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.preposition = replacementvalue || "";
                                }
                                break;
                            }
                        case "IMPORTANT":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bImportant) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bImportant = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "CARRYABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bCarryable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bCarryable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "WEARABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bWearable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bWearable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "WORN":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bWorn) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bWorn = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "CONTAINER":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bContainer) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bContainer = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "OPENABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bOpenable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bOpenable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "OPEN":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bOpen) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bOpen = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "LOCKABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bLockable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bLockable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "LOCKED":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bLocked) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bLocked = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "VISIBLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bVisible) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bVisible = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "ENTERABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bEnterable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bEnterable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "READABLE":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bReadable) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bReadable = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "WEIGHT":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.dWeight) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.dWeight = parseFloat(replacementvalue || "0");
                                }
                                break;
                            }
                        case "OVERRIDENAME":
                            {
                                text = text.slice(0, tempindex) + tempobject.CharnameOverride + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.CharnameOverride = replacementvalue || "";
                                }
                                break;
                            }
                        case "GENDER":
                            {
                                switch (AttType) {
                                    case "ca":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.CharGender + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.CharGender = replacementvalue || "";
                                            }
                                            break;
                                        }
                                    case "pa":
                                        {
                                            text = text.slice(0, tempindex) + tempobject.PlayerGender + text.slice(tempindex);
                                            if (bReplacement) {
                                                tempobject.PlayerGender = replacementvalue || "";
                                            }
                                            break;
                                        }
                                }
                                break;
                            }
                        case "CURRENTROOM":
                            {
                                text = text.slice(0, tempindex) + tempobject.CurrentRoom + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.CurrentRoom = replacementvalue || "";
                                }
                                break;
                            }
                        case "ALLOWINVINTERACTION":
                            {
                                text = text.slice(0, tempindex) + String(tempobject.bAllowInventoryInteraction) + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.bAllowInventoryInteraction = (replacementvalue?.toLowerCase() == "true");
                                }
                                break;
                            }
                        case "CURROOM":
                            {
                                if (tempobject.CurrentRoom != null)
                                    text = text.slice(0, tempindex) + tempobject.CurrentRoom + text.slice(tempindex);
                                else
                                    text = text.slice(0, tempindex) + "<Null>" + text.slice(tempindex);
                                if (bReplacement && TheGame) {
                                    TheGame.Player.CurrentRoom = replacementvalue || "";
                                }
                                break;
                            }
                        case "CURPORTRAIT":
                            {
                                text = text.slice(0, tempindex) + tempobject.PlayerPortrait + text.slice(tempindex);
                                if (bReplacement) {
                                    tempobject.PlayerPortrait = replacementvalue || "";
                                }
                                break;
                            }
                    }
                }
            }
        }
        tempindex = text.lastIndexOf("[" + AttType + ":");
    }
    return text;
}

/**
 * Convert variable array to JavaScript array string
 */
function JavaScriptArray(tempvar: Variable): string {
    let bValidType = false;
    let bWantQuotes = true;
    if (tempvar.vartype == "VT_NUMBERARRAY") {
        bWantQuotes = false;
        bValidType = true;
    } else if (tempvar.vartype == "VT_STRINGARRAY" || tempvar.vartype == "VT_DATETIMEARRAY") {
        bValidType = true;
    }
    if (!bValidType)
        return "";
    let newval = "[";
    let count = -1;
    if (tempvar.VarArray) {
        for (let i = 0; i < tempvar.VarArray.length; i++) {
            count++;
            if (count > 0)
                newval += ",";
            const row = tempvar.VarArray[i];
            if (row != null && Array.isArray(row)) {
                newval += "[";
                let count2 = -1;
                for (let j = 0; j < row.length; j++) {
                    const str = row[j];
                    count2++;
                    if (count2 > 0)
                        newval += ",";
                    if (bWantQuotes)
                        newval += "\"" + String(str).replace(new RegExp("\"", "g"), "\\\"") + "\"";
                    else
                        newval += String(str);
                }
                newval += "]";
            } else {
                if (bWantQuotes)
                    newval += "\"" + String(tempvar.VarArray[i]).replace(new RegExp("\"", "g"), "\\\"") + "\"";
                else
                    newval += String(tempvar.VarArray[i]);
            }
        }
    }
    newval += "];";
    return newval;
}

/**
 * Get action data for replacement
 */
function GetActionData(tempact: Action, part3: string, text: string, tempindex: number, replacementvalue?: string | null): string {
    let bReplacement = false;
    if (replacementvalue != null)
        bReplacement = true;
    switch (part3.toUpperCase()) {
        case "ACTIVE":
            {
                text = text.slice(0, tempindex) + String(tempact.bActive) + text.slice(tempindex);
                if (bReplacement) {
                    tempact.bActive = (replacementvalue?.toLowerCase() == "true");
                }
                break;
            }
        case "OVERRIDENAME":
            {
                text = text.slice(0, tempindex) + (tempact.overridename || "") + text.slice(tempindex);
                if (bReplacement) {
                    tempact.overridename = replacementvalue || "";
                }
                break;
            }
        case "ACTIONPARENT":
            {
                text = text.slice(0, tempindex) + (tempact.actionparent || "") + text.slice(tempindex);
                if (bReplacement) {
                    tempact.actionparent = replacementvalue || "";
                }
                break;
            }
        case "INPUTTYPE":
            {
                text = text.slice(0, tempindex) + tempact.InputType + text.slice(tempindex);
                if (bReplacement) {
                    tempact.InputType = replacementvalue || "";
                }
                break;
            }
    }
    return text;
}

/**
 * Replace static text patterns
 */
function ReplaceStatic(text: string, tempindex: number, change: string, loopobject: any): string {
    if (tempindex < 0) {
        return text;
    }

    const staticReplacements: [string, () => string | undefined][] = [
        ['[PLAYERNAME]', () => {
            return TheGame ? TheGame.Player.Name : "";
        }],
        ['[INPUTDATA]', () => {
            const data = Globals.additionalData;
            if (data instanceof RagsObject) {
                return data.name;
            } else if (data instanceof Character) {
                // XXX Can never happen? additionalData is either an object or a string.
                return data.Charname;
            }
            return data;
        }],
        ['[MAXCARRY]', () => {
            return TheGame ? String(TheGame.Player.dWeightLimit) : "0";
        }],
        ['[TURNS]', () => {
            return TheGame ? String((TheGame as any).TurnCount || 0) : "0";
        }],
        ['[CURRENTCARRY]', () => {
            let totalweight = 0;
            Interactables.inventoryObjects().forEach((obj) => {
                totalweight += (window as any).GetItemWeight?.(obj.UniqueIdentifier) || 0;
            });
            return String(totalweight);
        }],
        ['[MAN/WOMAN]', () => {
            if (!TheGame) return "";
            switch (TheGame.Player.PlayerGender) {
                case "Female":
                    return "woman";
                case "Male":
                    return "man";
                case "Other":
                    return "thing";
                default:
                    return "";
            }
        }],
        ['[MALE/FEMALE]', () => {
            return TheGame ? TheGame.Player.PlayerGender.toLowerCase() : "";
        }],
        ['[GIRL/BOY]', () => {
            if (!TheGame) return "";
            switch (TheGame.Player.PlayerGender) {
                case "Female":
                    return "girl";
                case "Male":
                    return "boy";
                case "Other":
                    return "thing";
                default:
                    return "";
            }
        }],
        ['[ROOM.NAME]', () => {
            const temproom = loopobject;
            if (temproom != null)
                return temproom.Name;
            else {
                if (TheGame && TheGame.Player.CurrentRoom != null) {
                    const room = Finder.room(TheGame.Player.CurrentRoom);
                    return room ? room.Name : "";
                }
            }
            return "";
        }],
        ['[ROOM.ID]', () => {
            const temproom = loopobject;
            if (temproom != null)
                return temproom.UniqueID;
            else {
                if (TheGame && TheGame.Player.CurrentRoom != null) {
                    const room = Finder.room(TheGame.Player.CurrentRoom);
                    return room ? room.UniqueID : "";
                }
            }
            return "";
        }],
        ['[EXIT.ACTIVE]', () => {
            if (loopobject != null) {
                return loopobject.bActive ? "Y" : "N";
            }
            return "";
        }],
        ['[EXIT.DIRECTION]', () => {
            return loopobject ? loopobject.Direction : "";
        }],
        ['[EXIT.DESTNAME]', () => {
            if (loopobject != null) {
                const room = Finder.room(loopobject.DestinationRoom);
                return room ? room.Name : "";
            }
            return "";
        }],
        ['[EXIT.DESTID]', () => {
            return loopobject ? loopobject.DestinationRoom : "";
        }],
        ['[ITEM.NAME]', () => {
            return loopobject ? loopobject.name : "";
        }],
        ['[ITEM.ID]', () => {
            return loopobject ? loopobject.UniqueIdentifier : "";
        }],
        ['[CHAR.NAME]', () => {
            return loopobject ? loopobject.Charname : "";
        }],
        ['[A/AN]', () => {
            const check = text.substring(tempindex).trim();
            if (check.length >= 1) {
                const firstChar = check[0].toLowerCase();
                if (firstChar == "a" || firstChar == "e" || firstChar == "i" || firstChar == "o" || firstChar == "u") {
                    return "an";
                } else {
                    return "a";
                }
            }
            return "";
        }]
    ];

    for (let i = 0; i < staticReplacements.length; i++) {
        const str = staticReplacements[i][0];
        const func = staticReplacements[i][1];
        if (change.indexOf(str) > -1) {
            const replacement = func() || '';
            return text.slice(0, tempindex) + replacement + text.slice(tempindex + str.length);
        }
    }

    // TODO: check this
    if (tempindex >= 0 && change.indexOf("[LEN(") > -1) {
        let lenIndex = change.indexOf("[LEN(", 0);
        let tempvar: Variable | undefined = undefined;
        const endlenindex = text.indexOf(")]", tempindex);
        if (endlenindex >= 0) {
            lenIndex += 5;
            const varname = text.substring(lenIndex, endlenindex);
            tempvar = Finder.variable(varname);
        }
        if (tempvar) {
            text = text.slice(0, lenIndex - 5) + text.slice(endlenindex + 2);
            switch (tempvar.vartype) {
                case "VT_STRING":
                    {
                        text = text.slice(0, lenIndex - 5) + String(tempvar.sString.length) + text.slice(lenIndex - 5);
                        break;
                    }
                case "VT_STRINGARRAY":
                case "VT_NUMBERARRAY":
                case "VT_DATETIMEARRAY":
                    {
                        text = text.slice(0, lenIndex - 5) + String(tempvar.VarArray?.length || 0) + text.slice(lenIndex - 5);
                        break;
                    }
            }
        } else {
            text = text.slice(0, tempindex) + text.slice(tempindex + 5);
        }
        lenIndex = text.indexOf("[len(", 0);
    }

    return text;
}

/**
 * Get item weight (including contained items)
 */
export function GetItemWeight(objid: string): number {
    let retval = 0;
    const tempobj = Finder.object(objid);
    if (tempobj != null) {
        retval += tempobj.dWeight;
        if (tempobj.bContainer && TheGame) {
            for (let i = 0; i < TheGame.Objects.length; i++) {
                const containedobj = TheGame.Objects[i];
                if (containedobj.locationtype == "LT_IN_OBJECT" && containedobj.locationname == tempobj.UniqueIdentifier) {
                    retval += GetItemWeight(containedobj.UniqueIdentifier);
                }
            }
        }
    }
    return retval;
}

/**
 * Strip out formatting tags
 */
export function StripOut(value: string, temptext: string): string {
    if (value == "[f" || value == "[c") {
        let index = temptext.indexOf(value, 0);
        while (index >= 0) {
            let endindex = temptext.indexOf("]", index);
            if (endindex >= 0) {
                temptext = temptext.slice(0, index) + temptext.slice(endindex + 1);
                const valueend = "[/" + value[1] + "]";
                endindex = temptext.indexOf(valueend, index);
                if (endindex >= 0) {
                    temptext = temptext.slice(0, endindex) + temptext.slice(endindex + 4);
                }
            }
            index = temptext.indexOf(value, 0);
        }
    } else {
        const lowerValue = value.toLowerCase();
        let index = temptext.indexOf(lowerValue, 0);
        while (index >= 0) {
            temptext = temptext.slice(0, index) + temptext.slice(index + lowerValue.length);
            index = temptext.indexOf(lowerValue, index);
        }
        const closingTag = lowerValue.slice(0, 1) + "/" + lowerValue.slice(1);
        index = temptext.indexOf(closingTag, 0);
        while (index >= 0) {
            temptext = temptext.slice(0, index) + temptext.slice(index + closingTag.length);
            index = temptext.indexOf(closingTag, index);
        }
    }
    return temptext;
}

/**
 * Get text with only middle tags (for formatting)
 */
export function MiddlesOnly(temptext: string): string {
    temptext = StripOut("[f", temptext);
    temptext = StripOut("[c", temptext);
    temptext = StripOut("[B]", temptext);
    temptext = StripOut("[i]", temptext);
    temptext = StripOut("[u]", temptext);
    return temptext;
}

/**
 * Get text only (strip all formatting)
 */
export function TextOnly(temptext: string): string {
    temptext = StripOut("[f", temptext);
    temptext = StripOut("[c", temptext);
    temptext = StripOut("[B]", temptext);
    temptext = StripOut("[Middle]", temptext);
    temptext = StripOut("[i]", temptext);
    temptext = StripOut("[u]", temptext);
    return temptext;
}

// Make functions globally available
(window as any).PerformTextReplacements = PerformTextReplacements;
(window as any).GetItemWeight = GetItemWeight;
(window as any).StripOut = StripOut;
(window as any).MiddlesOnly = MiddlesOnly;
(window as any).TextOnly = TextOnly;
